import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Container,
  Columns,
  Column,
  PasswordInput,
  Button,
} from '@resurs/midas-react'
import { midas } from '@resurs/midas'
import update from 'immutability-helper'
import { Conditional } from '@resurs/react-utils'

import passwordUpdate from '../../../higher-order/password-update'
import Page from '../../../internal/Page'
import { getText } from '../../../internal/TextLabels/text'

class ProfileUpdatePassword extends Component {
  constructor(props) {
    super(props)
    this.state = {
      oldPassword: null,
      password: null,
      retypePassword: null,
      mismatch: false,
    }
  }

  disabled() {
    if (
      !this.state.oldPassword ||
      !this.state.password ||
      !this.state.retypePassword
    ) {
      return true
    }
    if (this.state.oldPassword === this.state.password) {
      return true
    }
    if (!this.validPasswordLength()) {
      return true
    }
    return false
  }

  validPasswordLength() {
    return this.state.password && this.state.password.length >= 4
  }

  render() {
    return (
      <Page title={getText('profile.updateTitle')}>
        <Container>
          <Columns>
            <Column col12>
              <form
                onSubmit={e => {
                  e.preventDefault()
                  if (this.state.password === this.state.retypePassword) {
                    this.props.onSetPassword(e)
                  } else {
                    this.setState(state =>
                      update(state, {
                        mismatch: { $set: true },
                      }),
                    )
                  }
                }}
              >
                <PasswordInput
                  id="old-password"
                  name="old-password"
                  label={getText('profile.oldPassword.label')}
                  required={getText('profile.oldPassword.required')}
                  onChange={e =>
                    this.setState(state =>
                      update(state, {
                        oldPassword: { $set: e.target.value },
                      }),
                    )
                  }
                />
                <PasswordInput
                  id="password"
                  name="password"
                  label={getText('profile.newPassword.label')}
                  peekLabel={getText('profile.newPassword.peekLabel')}
                  peek
                  creation
                  creationLabels={[
                    getText('profile.newPassword.creationLabels.unsafe'),
                    getText('profile.newPassword.creationLabels.easy'),
                    getText('profile.newPassword.creationLabels.good'),
                    getText('profile.newPassword.creationLabels.verygood'),
                    getText('profile.newPassword.creationLabels.strong'),
                  ]}
                  required={getText('profile.newPassword.required')}
                  onChange={e =>
                    this.setState(state =>
                      update(state, {
                        password: { $set: e.target.value },
                        mismatch: { $set: false },
                      }),
                    )
                  }
                />
                {this.state.oldPassword &&
                  this.state.password &&
                  this.state.oldPassword === this.state.password && (
                    <div
                      style={{ padding: '1rem 0' }}
                      className={midas.hasWarning}
                    >
                      <span className={midas.formInputHint}>
                        {getText('password.error.oldAndNewMatch')}
                      </span>
                    </div>
                  )}
                <PasswordInput
                  id="retype-password"
                  name="retype-password"
                  label={getText('profile.repeatPassword.label')}
                  required={getText('profile.repeatPassword.required')}
                  onChange={e =>
                    this.setState(state =>
                      update(state, {
                        retypePassword: { $set: e.target.value },
                        mismatch: { $set: false },
                      }),
                    )
                  }
                />

                <Conditional
                  when={
                    !!this.state.password &&
                    !this.state.mismatch &&
                    !this.validPasswordLength()
                  }
                >
                  <div
                    style={{ padding: '1rem 0' }}
                    className={midas.hasWarning}
                  >
                    <span className={midas.formInputHint}>
                      {getText('password.error.tooShort')}
                    </span>
                  </div>
                </Conditional>
                {this.state.mismatch && (
                  <div
                    style={{ padding: '1rem 0' }}
                    className={midas.hasWarning}
                  >
                    <span className={midas.formInputHint}>
                      {getText('password.error.mismatch')}
                    </span>
                  </div>
                )}
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button form type="primary" disabled={this.disabled()}>
                    {getText('profile.save')}
                  </Button>
                </div>
              </form>
            </Column>
          </Columns>
        </Container>
      </Page>
    )
  }
}

ProfileUpdatePassword.propTypes = {
  onSetPassword: PropTypes.func.isRequired,
}

export default passwordUpdate(ProfileUpdatePassword)
